import { useEffect } from "react"

import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"

import { BA_STEPS } from "../Containers/GettingStartedPage/utils/businessSteps"
import { OB_STEPS } from "../Containers/GettingStartedPage/utils/onboardingSteps"
import { STEPS } from "../Containers/LayoutOnboarding/utils/constants/steps"
import {
  getBusinessPathByStepId,
  getOnboardingPathByStepId
} from "../Utils/onboarding/onboardingFlow"
import {
  CHOICE_FLOWS,
  hasOnboardingProgress,
  resolveProductChoice
} from "../Utils/onboarding/productChoice"
import {
  getApplicableSteps,
  getSkippedStepKeys,
  nextApplicableStepId
} from "../Utils/onboarding/stepSequence"

// Landing on a step the product choice skipped must move forward to the next applicable one
// (OB-X-01): the backend still points a Recover-only merchant at "Choose enrollment" after the
// integration step, and a saved link or a stale redirect can bring them there.
export const useSkippedStepRedirect = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const userInfo = useSelector((state) => state.auth?.userInfo)
  const nextCreateAccountStep = useSelector((state) => state.user?.nextCreateAccountStep)

  useEffect(() => {
    const isBusinessFlow = pathname.includes("/create-account")
    const currentKey = pathname.split("/")[2]
    const row = STEPS.find((s) => s.key === currentKey)

    if (!row) return

    const flow = isBusinessFlow ? CHOICE_FLOWS.BUSINESS : CHOICE_FLOWS.ONBOARDING
    const choice = resolveProductChoice({
      flow,
      hasProgress: hasOnboardingProgress({ flow, userInfo, nextCreateAccountStep })
    })

    if (!getSkippedStepKeys(choice).includes(row.step)) return

    const stepMap = isBusinessFlow ? BA_STEPS : OB_STEPS
    const target = nextApplicableStepId({
      stepId: stepMap[row.step] + 1,
      steps: getApplicableSteps({ choice }),
      stepMap
    })

    navigate(isBusinessFlow ? getBusinessPathByStepId(target) : getOnboardingPathByStepId(target), {
      replace: true
    })
  }, [pathname, userInfo, nextCreateAccountStep, navigate])
}
